export default __webpack_public_path__ + "static/media/tipCross.b6f652f3.svg";